import { render, staticRenderFns } from "./UiBtnBurger.vue?vue&type=template&id=89c1d0c6&scoped=true"
import script from "./UiBtnBurger.vue?vue&type=script&lang=js"
export * from "./UiBtnBurger.vue?vue&type=script&lang=js"
import style0 from "./UiBtnBurger.vue?vue&type=style&index=0&id=89c1d0c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c1d0c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89c1d0c6')) {
      api.createRecord('89c1d0c6', component.options)
    } else {
      api.reload('89c1d0c6', component.options)
    }
    module.hot.accept("./UiBtnBurger.vue?vue&type=template&id=89c1d0c6&scoped=true", function () {
      api.rerender('89c1d0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/UI/UiBtnBurger.vue"
export default component.exports